import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { authSelectors } from 'app-components/flux/auth';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { getLogger } from 'app-components/utils/core';
import { useAppDispatch, useAppSelector } from 'hooks/redux';

const log = getLogger('components/RootModal/useShowDialogQueryParam');

export const useShowDialogQueryParam = (): void => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useAppSelector(authSelectors.isAuthenticated);

  useEffect(() => {
    log.log('location changed to: ', location.pathname + location.search);
    // Keep supporting the legacy single-dialog query param while newer flows
    // use the structured dialogs param handled by useRootModalUrlDialogs.
    if (isAuthenticated) {
      const url = new URL(window.location.href);
      const dialogType = url.searchParams?.get('showDialog');
      if (dialogType) {
        switch (dialogType) {
          case 'SOME_SPECIAL_DIALOG_ID_EXAMPLE': // if we need special handling
            break;
          default:
            dispatch(
              rootUiActions.createDialog(
                rootUiTypes.mkRootUiData({
                  id: dialogType,
                  type: dialogType,
                  allowNesting: true,
                }),
              ),
            );
        }

        url.searchParams.delete('showDialog');
        navigate(url.pathname + url.search, { replace: true });
      }
    }
  }, [location, dispatch, navigate, isAuthenticated]);
};
